<div class="navbar navbar-expand-lg py-0 headerBg" role="banner">
    <div class="logo-m mr-2"
        *ngIf="(environment.appType === appType.LAB || isSplitWindow) && !lab?.EnableCustomLabDetailsPage">

        <div *ngIf="customLogo && customLogo.includes('CloudLabs')" class="navbar-brand" style="margin-left: 4px"
            aria-label="CloudLabs Logo">

            <img alt="CloudLabs Logo" class="mr-1" [src]="customLogo"
                style="height: 24px; width: auto; background: transparent" />
        </div>

        <div *ngIf="customLogo && !customLogo.includes('CloudLabs')" class="navbar-brand" style="margin-left: 4px"
            aria-label="Microsoft Logo">

            <img alt="Microsoft Logo" class="mr-1" [src]="customLogo"
                style="height: 20px; width: auto; background: transparent" />
        </div>

        <div *ngIf="!customLogo" class="navbar-brand" style="margin-left: 4px" aria-label="CloudLabs logo">

            <img alt="CloudLabs logo" class="mr-1" src="/assets/images/CloudLabs_Fullwhite.png"
                style="height: 24px; width: auto; background: transparent" />
        </div>

    </div>
    <span class="ml-2 separator"
        *ngIf="environment.appType === appType.LAB && showTitle && !lab?.EnableCustomLabDetailsPage">|</span>
    <div class="title-d left-section" *ngIf="showTitle" [ngbTooltip]="lab?.DisplayName ? lab?.DisplayName : lab?.Title" #tooltip5="ngbTooltip"
            triggers="manual" (mouseover)="tooltip5.open()" (mouseout)="tooltip5.close()" (click)="tooltip5.open()"
            [autoClose]="false"
        [ngClass]="{'pl-4':(environment.appType === appType.LAB && !lab?.EnableCustomLabDetailsPage)}">
        {{lab?.DisplayName ? lab?.DisplayName : lab?.Title}} 
    </div>
    <div class="right-section right-block ml-auto" [ngClass]="{'mb-1': environment.appType !== appType.ATTENDEE}">
        <div class="dropdown lang vm-selection text-right mt-4 mr-4" *ngIf="vmDetail && vmDetail.length > 1">
            <teams-button [classList]="'dropdown-toggle'" [style]="'font-size: small'"
                attr.aria-label="change vm {{ currentVm?.VMName }} selected" data-toggle="dropdown"
                aria-haspopup="listbox" [disabled]="isVmSwitchDisable" [ngClass]="isVmSwitchDisable ? 'disable-vmswitch' : ''">
                <i alt="" role="img" aria-label="img" aria-hidden="true" class="mr-1"
                    [ngClass]="currentVm?.Type === 'virtualMachines/hyperVm' ? 'fas fa-server' : 'fas fa-desktop' "></i>
                {{ hideFriendlyName ? currentVm.VMName : (currentVm.FriendlyName + ' - ' + currentVm.VMName) }} <i class="ml-1 fas fa-caret-down"></i>
            </teams-button>
            <div id="langDropdown" tabindex="-1" class="dropdown-menu" role="listbox">
                <a role="option" *ngFor="let vm of vmDetail" style="text-decoration: none"
                    class="vm-items dropdown-item navi-link ts-btn-fluent-white border-0"
                    attr.aria-label="{{ hideFriendlyName ? vm.VMName : (vm.FriendlyName + ' - ' + vm.VMName) }}" href="javascript:void(0)"
                    (click)="switchVm(vm)">
                    <i alt="" role="img" aria-label="img" aria-hidden="true" class="mr-2"
                        [ngClass]="vm.Type === 'virtualMachines/hyperVm' ? 'fas fa-server' : 'fas fa-desktop' "></i>
                    {{ hideFriendlyName ? vm.VMName : (vm.FriendlyName + ' - ' + vm.VMName) }}
                </a>
            </div>
        </div>
        <div class="end-date pr-3" *ngIf="endDateDetails && endDateDetails?.endDate && timerInSeconds > 0"
            [title]="('MESSAGE_ONDEMAND_LAB_END_DATE' | translate) +' '+ (endDateDetails?.endDate | date: 'dd MMM y, hh:mm a') +' '+ (endDateDetails?.timeZone)"
            role="button" data-toggle="tooltip" placement="bottom-left" trigger="hover">
            <i class="fa-solid fa-hourglass-end" style="margin-right: 0.25em;" aria-hidden="true"></i>
            {{endDateDetails?.endDate | date: 'dd MMM y, hh:mm a'}} {{endDateDetails?.timeZone}}
        </div>
        <div class="lab-time action-items pr-3"
            *ngIf="(endDateDetails === null || endDateDetails?.endDate === null) && timerInSeconds > 0">
            <i class="fa-regular fa-clock" style="margin-right: 0.25em;" aria-hidden="true"></i>
            <span style="font-size:small">{{countDown | async | formatTime}}</span>
        </div>
        <span class="separator"
            *ngIf="(endDateDetails === null || endDateDetails?.endDate === null) && timerInSeconds > 0">|</span>
        <ng-container
            *ngIf="(endDateDetails === null || endDateDetails?.endDate === null) && timerInSeconds > 0  && (lab?.EnableLabProgress && overallLabGuide !== undefined)">
            <div class="cursor-pointer" style="display: inline-block;"  (click)="onProgressClick('progress')">
                <div class="lab-time action-items progress ml-3 mr-1 cursor-pointer">
                    <p-progressBar class="no-value-bar" [style]="{ height: '10px' }" [value]="overallLabGuide">
                    </p-progressBar>
                </div>
                <span class="ml-2 mr-2">{{overallLabGuide}}%</span>
            </div>
        </ng-container>
        <!-- <span class="separator" *ngIf="(lab?.HasInlineQuestions || lab?.EnableLabValidation) && overallLabGuide !== undefined">|</span> -->
        <span class="separator"
            *ngIf="(endDateDetails === null || endDateDetails?.endDate === null) && timerInSeconds > 0  && (lab?.EnableLabProgress && overallLabGuide !== undefined)">|</span>
        <div class="dropdown lang zoom-selection text-right pl-3 mt-0" *ngIf="showZoomDropdown">
            <teams-button [classList]="'btn dropdown-toggle text-white'" [style]="'font-size: small'"
                attr.aria-label="change vm {{ currentZoomPer.name }} selected" data-toggle="dropdown"
                aria-haspopup="listbox" [tooltipText]="'ZOOM_IN_OUT' | translate">
                <img alt="CloudLabs logo" class="mr-1" src="/assets/images/Font-Resize-icon.svg"
                    style="height: 24px; width: auto; background: transparent" />
                <!-- : 
                {{ currentZoomPer.name }} -->
            </teams-button>
            <div id="langDropdown" tabindex="-1" class="dropdown-menu zoom-dropdown" role="listbox">
                <a role="option" *ngFor="let zoom of zoomPercentage" style="text-decoration: none"
                    class="d-block text-center vm-items dropdown-item navi-link ts-btn-fluent-white border-0"
                    attr.aria-label="{{ zoom.name }}" href="javascript:void(0)" (click)="zoomDoc(zoom)">
                    <span class="d-flex justify-content-between">
                        <span>
                            {{ zoom.name }}
                        </span>

                        <span *ngIf="currentZoomPer.name === zoom.name">
                            <i class="fa-solid fa-check" style="margin-right: 0.25em;" aria-hidden="true"></i>
                        </span>
                    </span>

                </a>
            </div>
        </div>

        <div class="action-items pr-3 pl-3" *ngIf="updatedActionList.length > 0">
            <ng-container *ngFor="let action of updatedActionList ; let i = index">
                <!-- {{action | json}} -->
                <ng-container *ngIf="action.action !== 'DEALLOCATE'">
                    <a role="button" href="javascript:void(0)" [title]="action.name | translate"
                        (click)="actionClick(action.action)">
                        <i [class]="action.icon" aria-hidden="true"></i>
                    </a>&nbsp; &nbsp;
                </ng-container>
                <!-- <i [class]="action.icon" [title]="action.name | translate" aria-hidden="true"
                    (click)="actionClick(action.action)"></i> &nbsp; -->
            </ng-container>
            <!-- Download icon for deleted-->
            <ng-container
                *ngIf="environment.appType === appType.ATTENDEE &&
                labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]?.EnableLabCompletionCertificate &&
                labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]?.CompletionCriteria !== null &&
                operationModes === 'Deployed'">
                <i
                class="fa-solid fa-download mr-3"
                aria-hidden="true"

                [class.disabled-certificate]="
                    labCompletionCertificate?.PercentageOfCompletion === null ||
                    labCompletionCertificate?.PercentageOfCompletion <
                    labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]?.CompletionCriteria
                "

                [ngbTooltip]="
                    labCompletionCertificate?.PercentageOfCompletion === null ||
                    labCompletionCertificate?.PercentageOfCompletion <
                    labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]?.CompletionCriteria
                    ? ('DISABLED_CERTIFICATE' | translate)
                    : ''
                "

                (click)="
                    labCompletionCertificate?.PercentageOfCompletion !== null &&
                    labCompletionCertificate?.PercentageOfCompletion >=
                    labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]?.CompletionCriteria
                    ? downloadLabCertificate()
                    : $event.preventDefault()
                "
                ></i>
            </ng-container>

            <!-- <cloudlabs-toggle-header class="mr-3" *ngIf="labLaunched"></cloudlabs-toggle-header> -->

            <!-- <div class="dropdown lang more-section text-right mt-4" *ngIf="showMore"
                [ngClass]="labLaunched ? 'ml-3' : '' ">
                <teams-button [classList]="'dropdown-toggle'" [style]="'font-size: small'" data-bs-auto-close="false"
                    data-toggle="dropdown" aria-haspopup="listbox" [titleText]="'MORE' | translate">
                          <i class="fas fa-ellipsis-h"></i>
                </teams-button>
                <div id="langDropdown" tabindex="-1" class="dropdown-menu" role="listbox" data-bs-auto-close="false">
                    <div class="dropdown-item" role="option">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="customSwitch1"
                                [(ngModel)]="currCopyOption" (change)="switchCopyOption()">
                            <label class="custom-control-label cursor-pointer" for="customSwitch1" (click)="$event.stopPropagation(); ">{{'FILE_TRANSFER' | translate}}</label>
                        </div>
                    </div>
                </div>
            </div> -->

            <ng-container *ngIf="showIPOption">
                <a role="button" href="javascript:void(0)" [title]="'IPV4_ADDRESS' | translate" (click)="showIP()">
                    <img alt="IP address icon" class="mt-0" src="/assets/images/Ip-address-icon.svg"
                        style="height: 14px; width: auto; background: transparent" />
                </a>&nbsp; &nbsp;
            </ng-container>
            <div class="dropdown d-inline" ngbDropdown #actionDropDn="ngbDropdown" [autoClose]="'outside'" style="bottom: 0.1em;"
                [placement]="'bottom-end'" *ngIf="(environment.appType !== appType.ATTENDEE && !lab?.EnableCustomLabDetailsPage) ||
                    (environment.appType === appType.ATTENDEE && labLaunched) || showDelete || showVMNative">
                <button class="btn dropdown-toggle topbar-item p-0" ngbDropdownToggle
                    [attr.aria-label]="'MORE' | translate" [title]="'MORE' | translate">
                    <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                </button>
                <div ngbDropdownMenu class="toggle-action-dropdown dropdown-menu">

                    <div ngbDropdown class="dropdown-submenu" [autoClose]="true" #parentDropdown="ngbDropdown"
                        *ngIf="environment.appType !== appType.ATTENDEE && !lab?.EnableCustomLabDetailsPage">
                        <a role="button" [title]="'LANGUAGE' | translate"
                            class="dropdown-item d-flex justify-content-between align-items-center icon-primary"
                            ngbDropdownToggle>
                            <span>
                                <i class="fa-solid fa-globe" aria-hidden="true"></i>
                                <!-- {{ 'LANGUAGE' | translate }} -->
                                <span class="ml-3">
                                    {{ 'LANGUAGE' | translate }}
                                </span>
                            </span>
                            <i class="fa-solid fa-angle-right"></i>
                        </a>

                        <!-- Submenu (Prevent Close on Click) -->
                        <div ngbDropdownMenu placement="top-left" id="langDropdown" class="dropdown-menu "
                            (click)="$event.stopPropagation()">
                            <button class="dropdown-item d-flex justify-content-between align-items-center icon-primary"
                                *ngFor="let language of languages" attr.aria-label="{{ language.Name }}"
                                (click)="switchLanguage(language.Code)">
                                <span>
                                    {{ language.Description }}
                                </span>
                                <i *ngIf="selectedLanguage === language.Code" class="fa-solid fa-check"
                                    style="margin-right: 0.25em;" aria-hidden="true"></i>
                            </button>

                        </div>
                    </div>

                    <a ngbDropdownItem href="javascript:void(0)" *ngIf="environment.appType === appType.ATTENDEE">
                        <div class="icon-primary">
                            <cloudlabs-toggle-header class="mr-3" *ngIf="labLaunched"
                                (click)="actionDropDn.close()"></cloudlabs-toggle-header>
                        </div>
                    </a>
                    <a ngbDropdownItem href="javascript:void(0)" *ngIf="showDelete">
                        <div class="icon-primary" (click)="actionClick('DEALLOCATE'); actionDropDn.close()">
                            <a role="button" [title]="'BUTTON_DELETE' | translate">
                                <i class="fa-solid fa-trash" aria-hidden="true"></i>
                            </a>
                            <span class="ml-3">
                                {{'BUTTON_DELETE' | translate}}
                            </span>

                            <!-- <label class="custom-control-label cursor-pointer" >{{'DELETE_LAB' | translate}}</label> -->
                        </div>
                    </a>
                    <a
                        ngbDropdownItem
                        href="javascript:void(0)"

                        *ngIf="labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]
                            ?.EnableLabCompletionCertificate && labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]
                            ?.CompletionCriteria !== null"

                        [class.disabled-certificate]="
                            !labCompletionCertificate?.PercentageOfCompletion ||
                            labCompletionCertificate?.PercentageOfCompletion <
                            labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]
                                ?.CompletionCriteria
                        "

                        [ngbTooltip]="
                            !labCompletionCertificate?.PercentageOfCompletion ||
                            labCompletionCertificate?.PercentageOfCompletion <
                            labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]
                                ?.CompletionCriteria
                            ? ('DISABLED_CERTIFICATE' | translate)
                            : ''
                        "
                        >
                        
                        <div
                            class="icon-primary"
                            (click)="
                        labCompletionCertificate?.PercentageOfCompletion &&
                        labCompletionCertificate?.PercentageOfCompletion >=
                            labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]?.CompletionCriteria
                            && downloadLabCertificate();
                        labCompletionCertificate?.PercentageOfCompletion &&
                        labCompletionCertificate?.PercentageOfCompletion >=
                            labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]?.CompletionCriteria
                            && actionDropDn.close();
                        (
                            !labCompletionCertificate?.PercentageOfCompletion ||
                            labCompletionCertificate?.PercentageOfCompletion <
                            labCompletionCertificate?.AllocatedTestDriveUserModelDetail[0]?.CompletionCriteria
                        )
                            && $event.preventDefault()
                        "
                        >
                            <i class="fa-solid fa-download" aria-hidden="true"></i>

                            <span class="ml-3">
                            {{ 'DOWNLOAD_CERTIFICATE' | translate }}
                            </span>
                        </div>
                        </a>
                    <ng-container *ngIf="showVMNative">
                        <hr class="solid mb-0">
                        <!-- <a ngbDropdownItem href="javascript:void(0)">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="customSwitch1"
                                    [(ngModel)]="currCopyOption" (change)="switchCopyOption()">
                                <label class="custom-control-label cursor-pointer" for="customSwitch1" (click)="$event.stopPropagation(); ">{{'FILE_TRANSFER' | translate}}</label>
                            </div>
                        </a> -->
                        <a ngbDropdownItem href="javascript:void(0)" class="mt-2">
                            <label class="d-flex justify-content-between align-items-center w-100 m-0 cursor-pointer"
                                for="customSwitch1" (click)="$event.stopPropagation();">
                                <span class="mr-3">
                                    {{ 'FILE_TRANSFER' | translate }}
                                </span>
                                <div class="custom-control custom-switch m-0">
                                    <input type="checkbox" class="custom-control-input" id="customSwitch1"
                                        [(ngModel)]="currCopyOption" (change)="switchCopyOption()">
                                    <span class="custom-control-label"></span>
                                </div>
                            </label>
                        </a>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="d-inline-flex" *ngIf="environment.appType === appType.LAB && studentName">
            <span class="separator ml-2">|</span>
            <span class="ml-2 student-name" [title]="studentName">{{studentName}}</span>
        </div>

        <!--Commented this translation section in header as due to User Story-5100 | Sheikh-->

        <div class="dropdown lang text-right mt-4 mr-2"
            *ngIf="environment.appType !== appType.ATTENDEE && !lab?.EnableCustomLabDetailsPage && !updatedActionList.length"
            [ngClass]="{'pl-3':updatedActionList.length <= 0}">
            <teams-button [classList]="'dropdown-toggle'" [style]="'font-size: small'"
                attr.aria-label="change Language {{ languageAriaLabel }} selected" data-toggle="dropdown"
                aria-haspopup="listbox">
                <i role="option" class="pr-1 fa-solid fa-globe" aria-hidden="true"></i>{{ showLanguage }}
            </teams-button>
            <div id="langDropdown" tabindex="-1" class="dropdown-menu" role="listbox">
                <a role="option" *ngFor="let language of languages" style="text-decoration: none" class="dropdown-item"
                    attr.aria-label="{{ language.Name }}" href="javascript:void(0)"
                    (click)="switchLanguage(language.Code)">{{ language.Description }}</a>
            </div>
        </div>

        <span class="separator" *ngIf="showTitle && environment.appType === appType.ATTENDEE">|</span>

        <div class="action-items" *ngIf="showTitle && environment.appType === appType.ATTENDEE">
            <teams-button [classList]="'btn p-0 text-white'" (buttonClick)="goBack()" [ariaLabel]="'CLOSE' | translate">
                <i class="fas fa-times pr-1 pl-2"></i>
                {{'CLOSE' | translate}}
            </teams-button>
            <!-- <span role="button" 
                aria-label="go to back" 
                tabindex="0" 
                class="back-opt cursor-pointer"
                (click)="goBack()">
                <i class="fas fa-times pr-1 pl-2"></i>
                {{'CLOSE' | translate}}
            </span> -->
        </div>

    </div>
</div>
<div class="header-pad"></div>